import { render, staticRenderFns } from "./CommercialInfo.vue?vue&type=template&id=8c967a26"
import script from "./CommercialInfo.vue?vue&type=script&lang=js"
export * from "./CommercialInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports